import { render } from "./RemoteControlView.vue?vue&type=template&id=7dde853f&scoped=true"
import script from "./RemoteControlView.vue?vue&type=script&lang=js"
export * from "./RemoteControlView.vue?vue&type=script&lang=js"

import "./RemoteControlView.vue?vue&type=style&index=0&id=7dde853f&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dde853f"]])

export default __exports__